"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _enums = require("./enums");
var _drawLottery = require("@/api/drawLottery");
var _permission = require("@/utils/permission");
var $constants = _interopRequireWildcard(require("@/utils/constants"));
var _clipboard = _interopRequireDefault(require("clipboard"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 权限判断函数

var tableFroms = {
  page: 1,
  limit: $constants.page.limit[0],
  keywords: '',
  activityStyle: ''
  // dateLimit: '',
};
var _default = exports.default = {
  name: 'ProductList',
  data: function data() {
    return {
      timeVal: [],
      listLoading: false,
      styleOptions: _enums.styleOptions,
      statusOptions: [{
        label: '未开始',
        value: 1
      }, {
        label: '进行中',
        value: 2
      }, {
        label: '已结束',
        value: 3
      }],
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: Object.assign({}, tableFroms),
      keywords: '',
      activityStyle: ''
    };
  },
  computed: {},
  activated: function activated() {
    this.handleSearchList();
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:lottery:activity:list'])) this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      // this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.tableFrom.page = 1;
      this.handleSearchList();
    },
    //添加商品
    handleAdd: function handleAdd() {
      //id:商品id，isDisabled：是否能编辑(noEdit不能，edit能)，isChoose：是否是选择商品(choose是，noChoose不是)
      this.$router.push({
        path: "/marketing/draw/activity/createActivity/0/add"
      });
    },
    //商品操作
    handleActivity: function handleActivity(row, operate) {
      //id:商品id，operate：操作类型(edit编辑，copy复制，detail详情不可编辑)
      this.$router.push({
        path: "/marketing/draw/activity/createActivity/".concat(row.activityId, "/").concat(operate)
      });
    },
    handleSearchList: function handleSearchList() {
      this.getList(1);
    },
    //重置
    handleReset: function handleReset() {
      this.tableFrom.keywords = '';
      this.tableFrom.activityStyle = '';
      this.keywords = '';
      this.activityStyle = '';
      this.timeVal = [];
      this.handleSearchList();
    },
    // 列表
    getList: function getList(num) {
      var _this = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.keywords = this.keywords;
      (0, _drawLottery.activityListApi)(this.tableFrom).then(function (data) {
        _this.tableData.data = data.list;
        _this.tableData.total = data.total;
        _this.listLoading = false;
      }).catch(function (res) {
        _this.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    handleCopy: function handleCopy() {
      var _this2 = this;
      this.$nextTick(function () {
        var clipboard = new _clipboard.default('.copy-data');
        clipboard.on('success', function () {
          _this2.$message.success('复制成功');
          clipboard.destroy();
        });
      });
    },
    formatter: function formatter(value, key) {
      if (key === 'activityStyle') {
        var target = this.styleOptions.find(function (item) {
          return item.value === value;
        });
        return target ? target.label : value;
      }
      if (key === 'status') {
        var _target = this.statusOptions.find(function (item) {
          return item.value === value;
        });
        return _target ? _target.label : value;
      }
      return '-';
    }
  }
};